import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import * as triplinkService from '../../utils/triplinkService';

export const finishStripeCheckout = createAsyncThunk(
  'checkout/finishStripeCheckoutSession',
  async (params: {session_id: string}, { dispatch, getState }) => {
    const state: RootState = (getState() as RootState);
    const accessToken = state.accessToken.body;//FIXME need to ensure this token is not expired
    if (!accessToken) {
      throw new Error('cannot finishStripeCheckout without access');
    }
    const result = await triplinkService.finishStripeCheckoutSession(accessToken, params);
    //TODO fetch fresh entitled-features, expert, and business after this.
    return result;
  }
)
